import React, { useEffect, useState } from 'react';
import {
  Autocomplete,
  InputAdornment,
  SxProps,
  TextField,
  Theme,
  createFilterOptions,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { findSelectAffiliateGroupState } from '../store/selectAffiliateGroupState/api';
import { useAppDispatch, useAppSelector } from '../store';

import Loader from './Loader';
import { AffiliateGroupState } from '../store/selectAffiliateGroupState/api/interface';

interface IProps {
  sx?: SxProps<Theme>;
  onAffiliateGroupStateSelected: (agState: AffiliateGroupState) => void;
}
const AffiliateGroupStateFilter: React.FC<IProps> = ({
  sx,
  onAffiliateGroupStateSelected,
}) => {
  // const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { data, isLoading, status } = useAppSelector(
    (state) => state.selectAffiliateGroupState
  );

  const [id, setId] = useState(-1);

  useEffect(() => {
    if (status === 'idle') {
      dispatch(findSelectAffiliateGroupState());
    }
  }, [status]);

  return (
    <Autocomplete
      loading={isLoading}
      loadingText={<Loader />}
      value={data?.filter((e) => e.id === id)?.[0] || null}
      onChange={(event, newValue) => {
        if (typeof newValue === 'string') {
        } else if (newValue) {
          setId(newValue.id);
          onAffiliateGroupStateSelected(newValue);
        }
      }}
      onInputChange={(event, newInputValue) => {
        if (!newInputValue) {
          setId(-1);
        }
      }}
      id='controllable-affiliate-group-state'
      disableClearable
      options={data}
      filterOptions={createFilterOptions({
        matchFrom: 'any',
        stringify: (option) => option.name,
      })}
      getOptionLabel={(option) => {
        if (typeof option === 'string') {
          return option;
        }
        return option?.name ?? '';
      }}
      fullWidth
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder='Select State'
          InputProps={{
            ...params.InputProps,
            type: 'search',
            sx,
            startAdornment: (
              <InputAdornment position='start'>
                <LocationOnIcon color='primary' />
              </InputAdornment>
            ),
          }}
        />
      )}
      ListboxProps={{
        role: 'list-box',
        style: {
          maxHeight: 300,
        },
      }}
    />
  );
};

export default AffiliateGroupStateFilter;
